import { Status, useProgrammaticCampaignHasInventoryQuery } from '../../__generated__/graphql'
import { EXISTENCE_CHECK_PAGINATION } from './archiveEntity.constants'

export const useProgrammaticCampaignArchiveEligibility = (
  campaignId: string,
  status: Status
): { canArchive: boolean; checking: boolean } => {
  const isInactive = status === Status.Inactive

  const { data, loading } = useProgrammaticCampaignHasInventoryQuery({
    variables: { campaignId, pagination: EXISTENCE_CHECK_PAGINATION },
    skip: !isInactive,
  })

  const hasChildren = (data?.campaignProgrammatic?.inventory.length ?? 0) > 0

  return {
    canArchive: isInactive && !loading && !hasChildren,
    checking: isInactive && loading,
  }
}
